import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import VideoModalStore from './store';

const styles = require('./index.less');

/**
 * 视频播放弹窗
 * @param {Object} props
 * @param {VideoModalStore} props.store - 弹窗状态管理
 * @param {Function} props.onClose - 关闭回调
 */
const VideoModal = ({ store, onClose }) => {
  store.use();
  const videoRef = React.useRef(null);

  if (onClose) {
    store.onClose = onClose;
  }

  // 弹窗关闭时暂停视频
  React.useEffect(
    () => {
      if (!store.isOpen && videoRef.current) {
        videoRef.current.pause();
      }
    },
    [store.isOpen]
  );

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.videoModalRoot)}>
        <div className={styles.videoWrapper}>
          {store.videoUrl && (
            <video
              ref={videoRef}
              className={styles.video}
              src={store.videoUrl}
              controls
              autoPlay
              playsInline
              webkit-playsinline="true"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
            />
          )}
        </div>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(VideoModal, VideoModalStore);
